import React, { createContext, useContext, useState, useEffect } from 'react';

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ms_location') || 'null'); } catch { return null; }
  });

  const saveLocation = (loc) => {
    setLocation(loc);
    localStorage.setItem('ms_location', JSON.stringify(loc));
  };

  const clearLocation = () => {
    setLocation(null);
    localStorage.removeItem('ms_location');
  };

  // Auto-detect on first visit if no saved location
  useEffect(() => {
    if (!location && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude: lat, longitude: lng } = pos.coords;
          try {
            const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
            const data = await res.json();
            const addr = data.address || {};
            saveLocation({
              lat, lng,
              city: addr.city || addr.town || addr.village || '',
              state: addr.state || '',
              display: addr.city || addr.town || `${lat.toFixed(3)}, ${lng.toFixed(3)}`
            });
          } catch {
            saveLocation({ lat, lng, display: `${lat.toFixed(3)}, ${lng.toFixed(3)}` });
          }
        },
        () => {} // silent fail on auto-detect
      );
    }
  }, []);

  return (
    <LocationContext.Provider value={{ location, saveLocation, clearLocation }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation2 = () => useContext(LocationContext);